import React, { useState, useEffect } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import Link from "next/link";
import { useRouter } from "next/router";
import { useForm } from "react-hook-form";
import { Button } from "components/button";
import { CustomInput } from "components/custom-input";
import { Input } from "components/input";
import { ErrorP } from "components/input/input.style";
import { useThisUser } from "contexts/user-context";
import { completeSignup } from "pages/api/api_actions";
import { TC } from "../signp.styles";
import { userSchema } from "./input-validations";

type UseRegisterForm = {
   password: string;
   confirmPassword: string;
   acceptTerms: boolean;
};

declare global {
   interface Window {
      metr: any;
   }
}

const CompleteSignup2 = () => {
   const [isLoading, setIsLoading] = useState<boolean>(false);
   const [password, setPassword] = useState<string>("");
   const [confirmPassword, setConfirmPassword] = useState("");
   const [url, setUrl] = useState<string>("");
   const [firstname, setFirstname] = useState<string>("");
   const [lastname, setLastname] = useState<string>("");
   const { dispatch, userState } = useThisUser();
   const router = useRouter();
   const query: any = router.query;

   const {
      register,
      handleSubmit,
      formState: { errors },
      watch,
   } = useForm<UseRegisterForm>({
      resolver: yupResolver(userSchema),
   });

   const [passErr, setPassErr] = useState(false);
   const [termsErr, setTermsErr] = useState(false);
   const [checkedTerms, setCheckedTerms] = useState(false);
   const submitHandler = (e) => {
      e.preventDefault();
      const passRegex =
         /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d@#$!%*?^_()+=&]{8,}$/;

      setIsLoading(true);

      if (!passRegex.test(password)) {
         setIsLoading(false);
         setPassErr(true);
      }

      if (!checkedTerms) {
         setTermsErr(true);
      }

      if (confirmPassword !== password && checkedTerms) {
         setIsLoading(false);
      } else {
         dispatch({
            type: "set_user",
            payload: {
               email: query?.email,
               password: password,
            },
         });
         if (window.metr) {
            window.metr("event", "leads", {
               customer_id: query?.email,
               name: `${firstname} ${lastname}`,
               email: query?.email,
               metadata: {},
            });
         }

         completeSignup(
            query?.integration,
            query?.shop,
            dispatch,
            {
               apiKey: query?.apiKey,
               email: query?.email,
               domain: url,
               firstname: firstname,
               lastname: lastname,
               password: password,
            },
            setIsLoading,
            router
         );
      }
   };
   useEffect(() => {
      console.log("wixintegration", query);
      localStorage.removeItem("shop");
   }, []);
   // const onSubmit = () => {
   //    setIsLoading(true);
   //    // console.log(query);
   //    alert("Here");
   //    dispatch({
   //       type: "set_user",
   //       payload: {
   //          email: query?.email,
   //          password: password,
   //       },
   //    });
   //    completeSignup(
   //       query?.integration,
   //       dispatch,
   //       {
   //          apiKey: query?.apiKey,
   //          email: query?.email,
   //          domain: url,
   //          firstname: firstname,
   //          lastname: lastname,
   //          password: password,
   //       },
   //       setIsLoading,
   //       router
   //    );

   //    setIsLoading(false);
   // };
   return (
      <div>
         <div className="text-block">
            <div className="base">
               <small>STEP 1 OF 3</small>
               <p>Personal Info</p>
            </div>
            <div className="info">
               <h2>
                  First step - set up your account, create and launch your new affiliate program in
                  minutes!
               </h2>
               <p>
                  Metricks is currently in BETA and is completely free to use. You will also be
                  notified before the billing cycle begins.
               </p>
            </div>
         </div>

         {/* <form onSubmit={handleSubmit(onSubmit)}> */}
         <form onSubmit={submitHandler}>
            <CustomInput
               type="text"
               id="url"
               tag="This is your affiliates’ dashboard domain login URL. You can always change the address"
               label="Affiliate domain URL"
               value={url}
               required={true}
               onChange={(e) => setUrl(e.target.value)}
            />

            <Input
               endAdornment
               label="First name"
               id="firstName"
               value={firstname}
               required={true}
               onChange={(e) => setFirstname(e.target.value)}
            />
            <Input
               endAdornment
               label="Last name"
               id="lastName"
               value={lastname}
               onChange={(e) => setLastname(e.target.value)}
            />
            <Input
               endAdornment
               label="Password"
               id="password"
               type="password"
               // error={errors.password?.message}
               error={
                  passErr &&
                  "Atleast 8 characters including uppercase, lowercase and special characters."
               }
               value={password}
               tag="Atleast 8 characters including uppercase, lowercase, number, and special characters."
               onChange={(e) => setPassword(e.target.value)}
               required={true}
            />
            <Input
               endAdornment
               label="Confirm Password"
               id="confirmPassword"
               type="password"
               // error={errors.confirmPassword?.message}
               error={
                  confirmPassword !== "" && confirmPassword !== password && "Passwords must match"
               }
               value={confirmPassword}
               onChange={(e) => setConfirmPassword(e.target.value)}
               required={true}
               // defaultValue={
               //    userState.domain === "" ? watch("confirmPassword") : userState.password
               // }
               // {...register("confirmPassword")}
            />
            <div style={{ marginBottom: "2.0em" }}>
               <TC>
                  <input
                     type="checkbox"
                     // {...register("acceptTerms")}
                     id="accept"
                     required={true}
                     // checked={watch("acceptTerms")}
                     checked={checkedTerms}
                     onChange={() => setCheckedTerms(true)}
                  />
                  <p>
                     I have read and accepted Metricks&apos;s
                     <Link href="/terms-of-service">Terms of Service</Link> and
                     <Link href="/privacy-policy"> Privacy Policy </Link>and hereby agree to receive
                     occasional communication with product news and relevant educational content.
                  </p>
               </TC>
               {termsErr && (
                  <ErrorP
                     initial="pageInitial"
                     animate="pageAnimate"
                     exit="pageExit"
                     variants={{
                        pageInitial: {
                           opacity: 1,
                           x: 0,
                           y: -5,
                        },
                        pageAnimate: {
                           opacity: 1,
                           x: 0,
                           y: 0,
                        },
                        pageExit: {
                           opacity: 0,
                        },
                     }}
                     id={"accept-message-text"}
                  >
                     Please, Accept Terms and Conditions.
                  </ErrorP>
               )}
            </div>

            <Button
               type="submit"
               // onClick={() => onSubmit()}
               variant="primary"
               className="ripple"
               fullWidth={true}
               isLoading={isLoading}
               style={{ fontSize: 16, fontWeight: 500, textTransform: "uppercase" }}
            >
               continue
            </Button>
         </form>
      </div>
   );
};

export { CompleteSignup2 };
